import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "antiqueFilled"
const AntiqueFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M6.375 15C7.411 15 8.25 15.84 8.25 16.875S7.41 18.75 6.375 18.75 4.5 17.91 4.5 16.875 5.34 15 6.375 15M18.375 15C19.41 15 20.25 15.84 20.25 16.875S19.41 18.75 18.375 18.75 16.5 17.91 16.5 16.875 17.34 15 18.375 15" />
          <path
            fillRule="evenodd"
            d="M12.315 8.813C12.785 8.813 13.22 9.065 13.455 9.473L14.577 11.438H17.492C16.59 11.79 15.622 12.35 14.735 13.236 13.384 14.586 12.785 15.765 12.53 16.629Q12.464 16.862 12.428 17.062H8.992Q8.999 16.97 9 16.876C9 15.425 7.825 14.25 6.375 14.25S3.75 15.425 3.75 16.875Q3.751 16.969 3.758 17.063H2.66C2.123 17.063 1.688 16.627 1.688 16.09V15H2.25C2.56 15 2.813 14.748 2.813 14.438S2.56 13.875 2.25 13.875H1.87C2.32 12.519 3.563 11.525 5.05 11.443L7.391 9.622C8.066 9.097 8.896 8.812 9.75 8.812zM9.188 9.998C8.788 10.083 8.408 10.256 8.082 10.51L6.89 11.438H9.187zM10.312 11.438H13.28L12.477 10.032C12.445 9.974 12.382 9.938 12.315 9.937H10.313z"
            clipRule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M20.625 11.063C20.935 11.063 21.188 11.314 21.188 11.625V12.406C21.878 13.057 22.313 13.977 22.313 15V16.154C22.313 16.655 21.905 17.063 21.403 17.063H20.993Q20.999 16.97 21 16.875C21 15.425 19.825 14.25 18.375 14.25S15.75 15.425 15.75 16.875Q15.751 16.969 15.758 17.063H13.193Q13.217 16.957 13.251 16.84C13.466 16.11 13.991 15.038 15.265 13.765 16.512 12.518 17.938 11.982 19.058 11.758 19.375 11.695 19.666 11.658 19.921 11.635Q19.993 11.662 20.063 11.69V11.625C20.063 11.315 20.314 11.063 20.625 11.063M13.67 16.638V16.636z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default AntiqueFilledIcon
